import { Component, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {RouterOutlet,Router} from '@angular/router';
import { Html5Qrcode } from 'html5-qrcode';
import { BookingService} from '../../../../../core/services/booking.service';
import { CommonSessionService } from '../../../../../core/services//common/common-session.service';
import { finalize } from 'rxjs/operators';
import { CandidateSessionService } from '../../../../../core/services/auth/auth.service';

@Component({
  selector: 'app-scan-qr',
  standalone: true,
  imports: [
    RouterOutlet,
    FormsModule
  ],

  templateUrl: './scan-qr.html'
})
export class ScanQRComponent
  implements OnDestroy {

  showQrScreen = true;

  bookingId = '';

  dob = '';

  isLoading = false;

  toastMessage = '';

  showToastMessage = false;

  isScanning = false;

  scanMessage = '';

  scanSuccess = false;

  userId: number | null = null;

  verifiedBookingId: number | null = null;
  private qrProcessing = false;
  private qrScanner: Html5Qrcode | null = null;


  constructor(
    private router: Router,
    private bookingService: BookingService,
    private commonService: CommonSessionService,
    private candidateSession: CandidateSessionService,
    private cdr: ChangeDetectorRef
  ) {}


startQrScan(): void {
  this.scanMessage = '';
  this.scanSuccess = false;
  this.isScanning = true;
  this.qrProcessing = false;

  setTimeout(async () => {
    try {
      // Prevent creating multiple scanner instances
      if (this.qrScanner) {
        await this.stopQrScan();
      }

      this.qrScanner = new Html5Qrcode('qr-reader');

      console.log('Starting QR scanner...');

      await this.qrScanner.start(
        { facingMode: 'environment' },
          {
            fps: 10,
            qrbox: {
              width: 250,
              height: 250
            },
            aspectRatio: 1.0
          },
          (decodedText: string) => {
            console.log('QR DETECTED:', decodedText);

            this.handleQrResult(decodedText);
          },

        (errorMessage: string) => {
          // This is called continuously when QR is not detected.
          // Don't show it to the user.
          console.debug('QR scan attempt:', errorMessage);
        }
      );

      console.log('QR scanner started successfully');

    } catch (error) {
      console.error('QR scanner start failed:', error);

      this.isScanning = false;
      this.qrScanner = null;

      this.scanSuccess = false;
      this.scanMessage =
        'Unable to access camera. Please allow camera permission.';

      this.showToast(
        'Unable to access camera.'
      );
    }
  }, 300);
}


private async handleQrResult(decodedValue: string): Promise<void> {

  if (this.qrProcessing) {
    console.log('QR processing already in progress.');
    return;
  }

  this.qrProcessing = true;

 console.log('==============================');
  console.log('QR VALUE:', decodedValue);
  console.log('==============================');

  // Remove everything except numbers (0-9)
  const numbersOnly = decodedValue.replace(/\D/g, '');
  const bookingId = Number(numbersOnly);

  console.log('Parsed Booking ID:', bookingId);

  // If no numbers were found, bookingId will be 0 or NaN
  if (!Number.isInteger(bookingId) || bookingId <= 0) {
    console.error('Invalid QR value:', decodedValue);
    this.qrProcessing = false;
    this.scanSuccess = false;
    this.scanMessage = 'Invalid QR code.';
    this.showToast('Invalid QR code.');
    this.cdr.detectChanges();
    return;
  }

  // Stop camera immediately after successful QR detection
  console.log('Stopping QR scanner...');

  await this.stopQrScan();

  console.log('QR scanner stopped.');

  this.isLoading = true;
  this.scanMessage = 'Verifying booking...';

  console.log(
    'Calling verifyBookingQr with Booking ID:',
    bookingId
  );

  this.bookingService
  .verifyBookingQr(
    bookingId,
    '',
    'QR'
  )
  .pipe(
    finalize(() => {

      console.log(
        'QR verification completed - stopping loader'
      );

      this.isLoading = false;

      this.cdr.detectChanges();
    })
  )
  .subscribe({

    next: (response) => {

      console.log(
        'verifyBookingQr RESPONSE:',
        response
      );

      if (!response || !response.success) {

        console.error(
          'Booking verification failed:',
          response
        );

        this.qrProcessing = false;
        this.scanSuccess = false;

        this.scanMessage =
          response?.message ??
          'Invalid QR code.';

        this.showToast(
          this.scanMessage
        );

        this.cdr.detectChanges();

        return;
      }

      // Backend verified booking
      this.scanSuccess = true;

      this.verifiedBookingId =
        response.bookingId ?? bookingId;

      this.userId =
        response.userId ?? null;

      if (!response.accessToken) {

            console.error(
                'Exam access token missing from QR verification response.',
                response
            );

            this.qrProcessing = false;
            this.scanSuccess = false;

            this.scanMessage =
                'Candidate examination session could not be created.';

            this.showToast(
                this.scanMessage
            );

            this.cdr.detectChanges();

            return;
        }

      this.scanMessage =
        'QR verified successfully.';

      this.showToast(
        'QR verified successfully.'
      );

      this.candidateSession.setSession(
        response.accessToken
    );

      if (
        this.verifiedBookingId !== null &&
        this.userId !== null
      ) {

        console.log(
          'Setting CommonSessionService session...'
        );

        this.commonService.setSession(
          this.verifiedBookingId,
          this.userId
        );

        console.log(
          'Navigating to exam instructions...'
        );

        this.router.navigate([
          '/exam/exam-panel/exam-instructions'
        ]);

      } else {

        console.error(
          'Missing Booking ID or User ID from API response.',
          response
        );

        this.qrProcessing = false;
        this.scanSuccess = false;

        this.scanMessage =
          'Booking verified, but candidate session information is missing.';

        this.showToast(
          this.scanMessage
        );
      }
    },

    error: (error) => {

      console.error(
        'verifyBookingQr API ERROR:',
        error
      );

      console.error(
        'HTTP status:',
        error?.status
      );

      console.error(
        'API error body:',
        error?.error
      );

      this.qrProcessing = false;
      this.scanSuccess = false;

      this.scanMessage =
        error?.error?.message ??
        'Invalid QR code. Please try again.';

      this.showToast(
        this.scanMessage
      );
    }
  });
}


  private showToast(
    message: string
  ): void {

    this.toastMessage = message;

    this.showToastMessage = true;

    setTimeout(() => {

      this.showToastMessage = false;

    }, 1000);

  }


  async stopQrScan(): Promise<void> {

    if (!this.qrScanner) {

      this.isScanning = false;

      return;
    }


    try {

      await this.qrScanner.stop();

      this.qrScanner.clear();

    }
    catch (error) {

      console.error(
        'Error stopping QR scanner:',
        error
      );

    }


    this.qrScanner = null;

    this.isScanning = false;

  }


  useBookingId(): void {

    this.stopQrScan();

    this.showQrScreen = false;

  }


  backToQrScan(): void {

    this.showQrScreen = true;

    this.scanMessage = '';

    this.scanSuccess = false;

  }


startExamWithBookingId(): void {

  if (!this.bookingId || !this.dob) {

    this.showToast(
      'Please enter Booking ID and Date of Birth.'
    );

    return;
  }

  const bookingId = Number(this.bookingId);

  if (
    isNaN(bookingId) ||
    bookingId <= 0
  ) {

    this.showToast(
      'Invalid Booking ID.'
    );

    return;
  }

  console.log(
    '➡️ Setting isLoading = TRUE'
  );

  this.isLoading = true;

  this.bookingService
    .verifyBookingQr(
      bookingId,
      this.dob,
      'BOOKING_ID'
    )
    .pipe(
      finalize(() => {

        console.log(
          '⬅️ FINALIZE: Setting isLoading = FALSE'
        );

        this.isLoading = false;

        this.cdr.detectChanges();

      })
    )
    .subscribe({

      next: (response) => {

        console.log(
          '✅ Booking verification response:',
          response
        );

        // -------------------------------------------------
        // Verification failed
        // -------------------------------------------------

        if (
          !response ||
          !response.success
        ) {

          this.showToast(
            response?.message ||
            'Booking ID or Date of Birth does not match.'
          );

          return;
        }

        // -------------------------------------------------
        // IMPORTANT:
        // Backend must return Candidate JWT
        // -------------------------------------------------

        console.log(
          '🎫 Access token received:',
          response.accessToken
            ? 'YES'
            : 'NO'
        );

        if (!response.accessToken) {

          console.error(
            '❌ Candidate access token missing.',
            response
          );

          this.showToast(
            'Candidate examination session could not be created.'
          );

          return;
        }

        // -------------------------------------------------
        // Save Candidate JWT
        // -------------------------------------------------

        this.candidateSession.setSession(
          response.accessToken
        );

        console.log(
          '✅ Candidate JWT saved in sessionStorage.'
        );

        console.log(
          'Stored token:',
          sessionStorage.getItem(
            'mensa_candidate_access_token'
          )
            ? 'FOUND'
            : 'NOT FOUND'
        );

        // -------------------------------------------------
        // Booking information
        // -------------------------------------------------

        this.userId =
          response.userId ?? null;

        this.verifiedBookingId =
          response.bookingId ?? bookingId;

        // -------------------------------------------------
        // Validate booking information
        // -------------------------------------------------

        if (
          this.verifiedBookingId === null
        ) {

          console.error(
            '❌ Booking ID missing from verification response.'
          );

          this.showToast(
            'Booking information is missing.'
          );

          return;
        }

        // -------------------------------------------------
        // Store Common Session
        // -------------------------------------------------

        this.commonService.setSession(
          this.verifiedBookingId,
          this.userId ?? 0
        );

        console.log(
          '✅ Common session created:',
          {
            bookingId: this.verifiedBookingId,
            userId: this.userId
          }
        );

        // -------------------------------------------------
        // Navigate
        // -------------------------------------------------

        console.log(
          '➡️ Navigating to exam instructions...'
        );

        this.router.navigate([
          '/exam/exam-panel/exam-instructions'
        ]);

      },

      error: (error) => {

        console.error(
          '❌ Booking verification failed:',
          error
        );

        console.error(
          'HTTP Status:',
          error?.status
        );

        console.error(
          'API Error:',
          error?.error
        );

        this.showToast(
          error?.error?.message ||
          'Booking ID or Date of Birth does not match.'
        );

      }

    });
}


  ngOnDestroy(): void {

    this.stopQrScan();

  }

}
